var map = {
	"./afghanistan-logo-icon.png": 52022,
	"./australia-logo-icon.png": 71486,
	"./australia-logo-icon.webp": 42343,
	"./bangladesh-logo-icon.png": 76757,
	"./bangladesh-logo-icon.webp": 60486,
	"./boland-logo-icon.webp": 71041,
	"./boland-rocks-logo-icon.webp": 57502,
	"./canada-logo-icon.png": 96392,
	"./chennai-super-kings-logo-icon.png": 30801,
	"./default-cricketzone-logo-icon.webp": 15888,
	"./delhi-capitals-logo-icon.png": 35342,
	"./dolphins-logo-icon.webp": 10158,
	"./durban's-super-giants-logo-icon.png": 90319,
	"./england-logo-icon.png": 37467,
	"./england-logo-icon.webp": 46464,
	"./gujarat-titans-logo-icon.png": 93754,
	"./india-logo-icon.png": 54365,
	"./india-logo-icon.webp": 79022,
	"./ireland-logo-icon.jpeg": 32050,
	"./ireland-logo-icon.png": 39997,
	"./italy-logo-icon.png": 71629,
	"./joburg-super-kings-logo-icon.png": 91592,
	"./knights-logo-icon.webp": 45555,
	"./kolkata-knight-riders-logo-icon.png": 38723,
	"./kwazulu-natal-inland-logo-icon.webp": 68434,
	"./lions-logo-icon.webp": 40734,
	"./lucknow-super-giants-logo-icon.png": 93964,
	"./mi-cape-town-logo-icon.png": 56437,
	"./mumbai-indians-logo-icon.png": 33676,
	"./namibia-logo-icon.png": 50471,
	"./nepal-logo-icon.jpg": 10506,
	"./netherlands-logo-icon.png": 93592,
	"./new-zealand-logo-icon.png": 19630,
	"./new-zealand-logo-icon.webp": 21303,
	"./north-west-dragons-logo-icon.webp": 47507,
	"./oman-logo-icon.png": 82867,
	"./paarl-royals-logo-icon.png": 95731,
	"./pakistan-logo-icon.png": 52571,
	"./pakistan-logo-icon.webp": 8096,
	"./pretoria-capitals-logo-icon.png": 15614,
	"./punjab-kings-logo-icon.png": 24837,
	"./rajasthan-royals-logo-icon.png": 66737,
	"./royal-challengers-bengaluru-logo-icon.png": 83054,
	"./scotland-logo-icon.png": 67074,
	"./south-africa-logo-icon.png": 54668,
	"./south-africa-logo-icon.webp": 52929,
	"./sri-lanka-logo-icon.png": 83230,
	"./sri-lanka-logo-icon.webp": 57927,
	"./sunrisers-eastern-cape-logo-icon.png": 43923,
	"./sunrisers-hyderabad-logo-icon.png": 39863,
	"./titans-logo-icon.webp": 53532,
	"./uae-logo-icon.png": 87059,
	"./usa-logo-icon.png": 1169,
	"./warriors-logo-icon.webp": 98916,
	"./west-indies-logo-icon.png": 22618,
	"./west-indies-logo-icon.webp": 44907,
	"./western-province-logo-icon.webp": 77106,
	"./zimbabwe-logo-icon.png": 99357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92046;